import request from '@/utils/request'


// 查询商品分类列表
export function listGoodsCategory(query) {
  return request({
    url: '/goods/goods/category/list',
    method: 'get',
    params: query
  })
}

// 查询商品分类分页
export function pageGoodsCategory(query) {
  return request({
    url: '/goods/goods/category/page',
    method: 'get',
    params: query
  })
}

// 查询商品分类详细
export function getGoodsCategory(data) {
  return request({
    url: '/goods/goods/category/detail',
    method: 'get',
    params: data
  })
}

// 新增商品分类
export function addGoodsCategory(data) {
  return request({
    url: '/goods/goods/category/add',
    method: 'post',
    data: data
  })
}

// 修改商品分类
export function updateGoodsCategory(data) {
  return request({
    url: '/goods/goods/category/edit',
    method: 'post',
    data: data
  })
}

// 删除商品分类
export function delGoodsCategory(data) {
  return request({
    url: '/goods/goods/category/delete',
    method: 'post',
    data: data
  })
}
